(function () {
    'use strict';
    var controllerId = 'stakTestAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'tipoTest', stakTestAdd]);

    function stakTestAdd($scope, $uibModalInstance, datacontext, tipoTest) {
        $scope.test = {};
        $scope.materie = [];
        $scope.bTitleChanged = false;
        $scope.tipoTest = tipoTest;

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.test);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };        

        function addItem(item) {
            item.layout = 1;
            return datacontext.stak_test_add(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) return null;

                return data;
            });
        }

        $scope.TitleChanged = function () {
            $scope.bTitleChanged = true;
            return false;
        };

        $scope.getMaterie = function (ricerca) {
            $scope.test.materia = ricerca;
            return datacontext.materia_getAll(0, 0, ricerca).then(function (data) {
                if (Array.isArray(data) && data.length > 0) {
                    $scope.materie = data;
                    return $scope.materie;
                }
                return null;
            });
        };

        $scope.setMateriaId = function (materia) {
            $scope.test.materiaId = materia.Id;
            $scope.test.materia = materia.Titolo;
        };

        $scope.checkMateria = function () {
            if (!$scope.test.materia)
                $scope.test.materiaId = 0;
        };
    }
})();